import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0;
  z-index: ${zIndexTypes.modal};
  width: 100vw;
  background: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const Modal = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 800px;
  border-radius: 8px;
  padding: 10px 20px;
  margin-left: 60px;
  position: relative;
  height: calc(100vh - 40px);
  overflow: hidden;

  canvas {
    width: 100% !important;
  }

  ${mediaMaxWidth.smallDesktop`
    margin-left: 0;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 10px);
    height: ${(props) =>
      props.iOS ? "calc(100vh - 85px)" : "calc(100vh - 10px)"};
    margin: 5px auto;
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;

  &:hover {
    background-color: #79D9D9;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  z-index: 1;
  right: 11px;
  font-size: 1.4em;
  top: 12px;
  background-color: #402680;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    background-color: #79D9D9;
  }
`;

export const Body = styled.div`
  margin: 0;
  overflow: scroll;
  height: calc(100vh - 110px);

  ${mediaMaxWidth.tablet`
    overflow-x: hidden;
  `}
`;

export const Footer = styled.div`
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #e4e5e7;

  &.hideFooter {
    height: 0;
  }
`;
